module.exports = __webpack_public_path__ + "static/media/Kasey M.7a6e74a6.jpg";